/**
 * Resolves a relative asset URL to an absolute URL using the API base URL.
 * If the URL is already absolute (starts with http), it is returned as is.
 */
export const resolveAssetUrl = (url: string | undefined): string | undefined => {
    if (!url) return undefined;
    
    // If it's already an absolute URL
    if (url.startsWith('http')) {
        // Upgrade to https for production domain if needed
        if (url.includes('mosaik-offenbach.de') && url.startsWith('http://')) {
            return url.replace('http://', 'https://');
        }
        return url;
    }
    
    const apiUrl = import.meta.env.VITE_API_URL || '';
    let apiBase = '';

    if (apiUrl) {
        apiBase = apiUrl.replace(/\/api$/, '');
    } else {
        // Fallback for production or local
        apiBase = window.location.origin;
    }

    // Force HTTPS for production domain
    if (apiBase.includes('mosaik-offenbach.de') && apiBase.startsWith('http://')) {
        apiBase = apiBase.replace('http://', 'https://');
    }
    
    const separator = url.startsWith('/') ? '' : '/';
    return `${apiBase.replace(/\/$/, '')}${separator}${url}`;
};
